const _ = require('lodash');

const {
  serializeImages,
  findImage
} = require('../utils/entities');

const CollectionScores = require('./collection-scores');

const lodashGet = require('lodash.get');

const {
  polygon,
  strinct
} = require('../utils/serialize');

const rewind = require('../utils/rewind');

const {
  dictionaryToGeoIds
} = require('../utils/filterQueries/geoids');
/*:: type CollectionInitObj = {
  id?: string,
  slug: string,
  name: string,
  shortName: string,
  desc: string,
  priority?: number,
  filterTags: Array<string>,
  flagNames: Array<string>,
  filterCategories: Array<string>,
  filterPlans: Array<string>,
  filterOffers: Array<GeoId>,
  filterBusinesses: Array<GeoId>,
  enabled: boolean,
  heroImage: ?string,
  iconLarge: ?string,
  iconSmall: ?string,
  heroImageUrl: ?string,
  iconLargeUrl: ?string,
  iconSmallUrl: ?string,
  scores: ?CollectionScores,
  scheduleIds?: Array<string>,
  meta: ?Object,
  polygons: ?Array<Array<Geopoint>>,
  businessFilter: ?any,
  businessOfferFilter: ?any,

  // Separate models in API
  // TODO: Move to CollectionEdit class
  tags?: Array<string>,
  regions?: Array<string>
};*/


class Collection {
  /*:: static fromJson: (Object) => Collection; */

  /*:: static serialize: (Collection) => Object; */
  constructor({
    /*: CollectionInitObj*/

    id,
    slug,
    name,
    shortName,
    desc,
    priority,
    filterTags,
    flagNames,
    filterCategories,
    filterPlans,
    filterOffers,
    filterBusinesses,
    enabled,
    heroImage,
    iconLarge,
    iconSmall,
    heroImageUrl,
    iconLargeUrl,
    iconSmallUrl,
    tags,
    regions,
    scores,
    scheduleIds,
    meta,
    polygons,
    businessFilter,
    businessOfferFilter
  } = {}) {
    this.id = id;
    this.slug = slug;
    this.name = name;
    this.shortName = shortName;
    this.desc = desc;
    this.priority = priority;
    this.filterTags = filterTags;
    this.flagNames = flagNames;
    this.filterCategories = filterCategories;
    this.filterPlans = filterPlans;
    this.hasFilterPlans = !!(this.filterPlans || []).length;
    this.filterOffers = filterOffers;
    this.filterBusinesses = filterBusinesses;
    this.enabled = enabled;
    this.heroImage = heroImage;
    this.iconLarge = iconLarge;
    this.iconSmall = iconSmall;
    this.heroImageUrl = heroImageUrl;
    this.iconLargeUrl = iconLargeUrl;
    this.iconSmallUrl = iconSmallUrl;
    this.tags = tags;
    this.regions = regions;
    this.scores = scores;
    this.scheduleIds = scheduleIds || [];
    this.meta = meta || {};
    this.polygons = polygons || [];
    this.businessFilter = businessFilter;
    this.businessOfferFilter = businessOfferFilter;
  }

} // FIXME: Don't wrap filter children as JSON when the DB accepts nested lists -- ask backend team if we can do this yet


Collection.fromJson = (json
/*: Object*/
) =>
/*: Collection*/
new Collection({
  id: json.id,
  slug: json.slug,
  name: json.name,
  shortName: json.shortName,
  desc: json.desc,
  priority: json.priority,
  enabled: json.enabled,
  heroImage: findImage(json.images, 'collection-hero-standard'),
  iconLarge: findImage(json.images, 'collection-icon-large'),
  iconSmall: findImage(json.images, 'collection-icon-small'),
  heroImageUrl: lodashGet(json, 'heroStandardImages[0].url'),
  iconLargeUrl: lodashGet(json, 'iconLargeImages[0].url'),
  iconSmallUrl: lodashGet(json, 'iconSmallImages[0].url'),
  filterTags: lodashGet(json, 'filters.tags', []),
  flagNames: lodashGet(json, 'filters.flags', []),
  filterCategories: lodashGet(json, 'filters.categories', []),
  filterPlans: lodashGet(json, 'filters.plans', []),
  filterOffers: dictionaryToGeoIds(lodashGet(json, 'filters.offerIds', {})),
  filterBusinesses: dictionaryToGeoIds(lodashGet(json, 'filters.businessIds', {})),
  scores: json.scores && new CollectionScores(json.scores),
  scheduleIds: json.scheduleIds,
  regions: json.regions,
  meta: json.meta,
  polygons: json.polygons,
  businessFilter: json.businessFilter,
  businessOfferFilter: json.businessOfferFilter
});

const serializeMeta = (meta
/*: ?Object*/
) =>
/*: ?Object*/
{
  if (!meta) return undefined;
  return {
    regions: {
      included: _.get(meta, 'regions.included', []),
      excluded: _.get(meta, 'regions.excluded', [])
    }
  };
};

const serializePolygons = (polygons
/*: ?Array<Array<Geopoint>>*/
) =>
/*: ?Array<Array<Geopoint>>*/
{
  if (!polygons) return undefined;
  return polygons.map(p => rewind(polygon(p)));
};

Collection.serialize = (collection
/*: Collection*/
) => (
/*: Object*/
{
  name: collection.name,
  shortName: collection.shortName,
  desc: strinct(collection.desc),
  priority: collection.priority,
  enabled: collection.enabled,
  images: serializeImages([collection.heroImage, collection.iconLarge, collection.iconSmall]),
  scores: CollectionScores.serialize(collection.scores),
  scheduleIds: collection.scheduleIds,
  meta: serializeMeta(collection.meta),
  polygons: serializePolygons(collection.polygons),
  businessFilter: collection.businessFilter,
  businessOfferFilter: collection.businessOfferFilter
});

module.exports = Collection;